import React, { useState } from "react";
import { IReducerAction } from "../../../store/reducer/types";
import { IState } from "../../../store/types";
import { ScreenProps } from "../../types";
import { Button, TextInput } from "../Common";
import { IActorInfo } from "../types";
import { actorActions, Actors } from "./Actors";
import { WaveUploader } from "./WaveUploader";

interface WaveLabelProps {
  waveName: string;
  setWaveName: React.Dispatch<React.SetStateAction<string>>;
}

function WaveLabel(props: WaveLabelProps) {
  const { waveName, setWaveName } = props;
  return (
    <div className="nes-field">
      <span>Wave Name</span>
      <TextInput text={waveName} setText={setWaveName} />
    </div>
  );
}

function AddActor({ addActor }: { addActor: () => void }) {
  return (
    <div>
      <Button onClick={addActor} label="Add Actor" />
    </div>
  );
}

function generateWaveActions(dispatch: React.Dispatch<IReducerAction>) {
  return {
    addGambit: (index: number) =>
      dispatch({ type: "gambit/add", payload: { index, id: "fixme" } }),
    addActor: () => dispatch({ type: "actor/add" }),
    onFinish: () =>
      dispatch({
        type: "screen/changeScreen",
        payload: { screen: "#multiplayer" }
      })
  };
}

function useActorInfo(state: IState) {
  const [actorInfo, setActorInfo] = useState<IActorInfo>({});
  const actors = state.actors.map(actor => {
    const frame = { name: actorInfo[actor.id] || actor.frame.name };
    return { ...actor, frame };
  });
  const onFrameChange = (actorId: string, frameName: string) => {
    setActorInfo(info => ({ ...info, [actorId]: frameName }));
  };
  return { actors, onFrameChange };
}

export default function WaveCreator({ dispatch, state }: ScreenProps) {
  // dictionary that maps state actor ids to props used to build waves (frameName for now).
  const [waveName, setWaveName] = useState("");
  const { actors, onFrameChange } = useActorInfo(state);

  const { addActor, onFinish, addGambit } = generateWaveActions(dispatch);
  const generateActorActions = (index: number) => actorActions(dispatch, index);

  return (
    <div id="multiplayer-wave-creator-screen">
      <h1>Wave Creator</h1>
      <h5>Create and upload your own wave</h5>
      <WaveLabel waveName={waveName} setWaveName={setWaveName} />
      <Actors
        actors={actors}
        onFrameChange={onFrameChange}
        generateActorActions={generateActorActions}
        addGambit={addGambit}
      />
      <AddActor addActor={addActor} />
      <WaveUploader waveName={waveName} actors={actors} onFinish={onFinish} />
    </div>
  );
}
